/*
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-28 13:32:38
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-04 17:50:58
 * @FilePath: /gamefi/stores/cansino/gameHistory.ts
 */
import { defineStore } from 'pinia';
import { useJoinStateStore} from '@/stores/cansino/joinState';

const historyInitialState = {
    gameOfRoute: "", // 表示“已经” 到达了某某游戏页面 
    gameName: "", // 表示“已经”查询到的某某游戏的历史 
    gameId: 0, // 表示…… 同上
    historyData: {
        response: [
            // {
            //     _id: '',
            //     amount: '19.5',
            //     currency: 'USDT',
            //     isIn: true,
            //     multi: 1.9804,
            //     predictionRange: [2500, 7499],
            //     randomSeed: '',
            //     timestamp: '',
            //     user: '',
            //     winAmount: 38.6178,
            //     bonusWinAmount: 0,
            //     hash: '',
            // },
        ],
        count: 0,
        providers: {},
    },
};
type GameHistoryState = Partial<typeof historyInitialState>;

export const useGameHistoryStore = defineStore('gameHistory', {
    state: () => historyInitialState,
    actions: {
        setState(partialState: GameHistoryState) {
            Object.assign(this, partialState);
        },
    },
    getters: {
        getState: (state) => state,
        // 👇返回 true 表示当前游戏历史信息已经加载完成
        isHistoryLoaded(state){
            return !!state.gameName && (state.gameName === state.gameOfRoute);
        },
        // 👇 返回 "当前游戏" 的历史，或空数据
        // 否则将会在游戏切换时取到上一个游戏的数据
        gameHistory(state){
            if ((state as any).isHistoryLoaded) {
                return state.historyData;
            }
            return {...historyInitialState.historyData};
        },
        // ↓ 游戏历史，排除状态为“延时”的数据，也排除状态为进行中的数据
        gameHistoryDelay(state){
            const response = (state as any).gameHistory.response?.filter((cur, idx) => {
                // ↓ 非 delay 才能显示
                const check01 = !cur.toDelay;
                return check01;
            });
            const oResult = {
                ...(state as any).gameHistory,
                response,
            };
            return oResult;
        },
    },
});


